import { useMutation, useQueryClient } from '@tanstack/react-query';
import { detachProductsFromGroup } from '../services/security-groups';

export function useDetachProductsMutation(groupId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (productIds: string[]) => detachProductsFromGroup(groupId, productIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'products'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });
}
